import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ItemNoAndType } from "../types/TaskDetailTypes";
import { getMostRecentAssignedTaskQueryKey } from "./queryKeyHelper";
import { getMostRecentAssignedTask } from "./tasks.service";

function getAttachedArticles(value: unknown): ItemNoAndType[] {
  if (Array.isArray(value)) {
    return value.flatMap(getAttachedArticles);
  }
  if (!value || typeof value !== "object") {
    return [];
  }
  if (
    "no" in value &&
    typeof value.no === "string" &&
    value.no.length === 8 &&
    "type" in value &&
    typeof value.type === "string" &&
    ["ART", "SPR", "SCI"].includes(value.type)
  ) {
    return [{ no: value.no, type: value.type }];
  }
  return Object.values(value).flatMap(getAttachedArticles);
}

export function useMostRecentAssignedTask(
  taskTypeId: string | null,
  details?: unknown
) {
  const storeId = useStoreId();
  const enabled = !!taskTypeId && !!storeId;
  const articles = getAttachedArticles(details);
  const article = articles.length === 1 ? articles[0] : undefined;

  return useQuery({
    queryKey: getMostRecentAssignedTaskQueryKey(taskTypeId, storeId, article),
    queryFn: () => {
      console.log("[last-assignee] Calling /tasks-v2/last-assignee", {
        taskTypeId,
        storeId,
      });
      return getMostRecentAssignedTask(taskTypeId!, storeId, article);
    },
    enabled,
    staleTime: 0,
  });
}
